import styled from 'styled-components';

const PageContainer = styled.div`
`;

const BreadcrumbsContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(1)};
`;

const EmptyMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const SearchFieldContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export { PageContainer,
  BreadcrumbsContainer,
  SearchFieldContainer,
  EmptyMessageContainer };
